import { render } from "./ManageAccessForm.vue?vue&type=template&id=93c775e8&scoped=true"
import script from "./ManageAccessForm.vue?vue&type=script&lang=js"
export * from "./ManageAccessForm.vue?vue&type=script&lang=js"

import "./ManageAccessForm.vue?vue&type=style&index=0&id=93c775e8&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c775e8"]])

export default __exports__